<template>
  <div class="faq vh-100">
    <MainNav />

    <div class="jumbotron bg-light">
      <div class="container">
        <h1>Frequently Asked Questions</h1>
      </div>
    </div>

    <!--- <div class="container">  Subheading container (Not needed?)
            <h2 class="lead">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vehicula id erat id elementum. Integer sed massa facilisis, tempus libero at, mattis libero. Donec consequat efficitur lacinia. Interdum et malesuada fames ac ante ipsum primis in faucibus. Suspendisse enim risus, tristique in nulla sit amet, facilisis maximus nisi. Nullam pulvinar nunc ut venenatis egestas. Nullam nec lorem efficitur leo varius porttitor.
            </h2>
        </div> --->

    <div class="container">
      <!--- Start of Accordion --->
      <div class="accordion" id="accordionOne">
        <!--- Card One --->
        <div class="card">
          <!--- Card Header --->
          <div class="card-header bg-light" id="headingOne">
            <button
              class="mb-0 btn btn-link text-dark"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
            >
              <h4 class="text-left">How do I get started?</h4>
            </button>
          </div>
          <!--- Card Body --->
          <div
            id="collapseOne"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionOne"
          >
            <div class="card-body">
              <!--- How to get started list group --->
              <ul class="list-group list-group-flush">
                <!--- Step One --->
                <li class="list-group-item">
                  <h5>
                    Step One:
                    <span class="h6"
                      >You need to request an ERCCIS Data Search account</span
                    >
                  </h5>
                  <p>
                    By completing the simple form at the bottom of the ERCCIS
                    data search landing page, you will be able to request an
                    ERCCIS Data Search account. You will need to provide your
                    name, email, company, address and the reason for your
                    searches. It is helpful for you to provide your phone number
                    in case we need to contact you directly, but not essential.
                  </p>
                </li>

                <!--- Step Two --->
                <li class="list-group-item">
                  <h5>
                    Step Two:
                    <span class="h6">Your account will be authorised</span>
                  </h5>
                  <p>
                    We aim that within 1 working day ERCCIS staff will review
                    your account request, but there may be times when an account
                    request could take longer to action. Please be aware that
                    ERCCIS might get in touch with you to discuss the
                    information products available as bespoke searches, as well
                    as through ERCCIS Data Search, before an account is
                    authorised.
                  </p>
                </li>

                <!--- Step Three --->
                <li class="list-group-item">
                  <h5>
                    Step Three: <span class="h6">You can start searching</span>
                  </h5>
                  <p>
                    You will receive an email allowing you to access the ERCCIS
                    Data Search system and you can then log in and start a
                    search using the bespoke mapping portal.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--- Card Two --->
        <div class="card">
          <!--- Card Header --->
          <div class="card-header bg-light" id="headingTwo">
            <button
              class="mb-0 btn btn-link text-dark collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              <h4 class="text-left">What are the costs?</h4>
            </button>
          </div>
          <!--- Card Body --->
          <div
            id="collapseTwo"
            class="collapse"
            aria-labelledby="headingTwo"
            data-parent="#accordionOne"
          >
            <div class="card-body">
              <p class="lead">
                The costs for an ERCCIS Data Search report are based on the size
                of your requested search radius. The current costs for an ERCCIS
                Data Search Report are as follows;
              </p>
              <ul>
                <li v-for="report in reports" :key="report.ReportTypeId">
                  {{ report.SearchRadius }}km {{ report.Name }} &mdash; &pound;{{ (report.ListPrice / 1.2).toFixed(2) }} Plus VAT
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--- Card Three --->
        <div class="card">
          <!--- Card Header --->
          <div class="card-header bg-light" id="headingThree">
            <button
              class="mb-0 btn btn-link text-dark collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              <h4 class="text-left">How long will it take?</h4>
            </button>
          </div>
          <!--- Card Body --->
          <div
            id="collapseThree"
            class="collapse"
            aria-labelledby="headingThree"
            data-parent="#accordionOne"
          >
            <div class="card-body">
              <p class="lead">
                We aim that all searches are completed and delivered in less
                than 30 minutes. If your search is taking more than 60 minutes,
                please get in touch at
                <a target="_blank" href="mailto:datasearch@erccis.org.uk"
                  >datasearch@erccis.org.uk</a
                >
                or phone
                <a target="_blank" href="tel:01872 302250">01872 302250</a>.
              </p>
            </div>
          </div>
        </div>
        <!--- Card Four --->
        <div class="card">
          <!--- Card Header --->
          <div class="card-header bg-light" id="headingFour">
            <button
              class="mb-0 btn btn-link text-dark collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              <h4 class="text-left">What will I receive?</h4>
            </button>
          </div>
          <!--- Card Body --->
          <div
            id="collapseFour"
            class="collapse"
            aria-labelledby="headingFour"
            data-parent="#accordionOne"
          >
            <div class="card-body">
              <p class="lead">
                You will receive the following as attachments by email:
              </p>
              <ul>
                <li>
                  Your (.pdf) report with all the designations, habitat and
                  notable species information for your study location.
                </li>
                <li>
                  A pre-filtered Excel sheet containing records of Species of
                  Conservation Concern (SoCC), with additions from the Cornwall
                  Red Data Book and the ERCCIS Invasive Species list.
                </li>
                <li>Your ERCCIS Data Search certificate.</li>
                <li>
                  An explanatory document (EDS Jargon buster.pdf) to explain the
                  acronyms used in the EDS report.
                </li>
                <li>(If relevant) your invoice for the commissioned report.</li>
              </ul>
              <p class="lead">
                You can also log into ERCCIS Data Search and see & download your
                current or previous reports (<a
                  href="https://datasearch.erccis.org.uk/reports/history"
                  >https://datasearch.erccis.org.uk/reports/history</a
                >) for up to 12 months.
              </p>
            </div>
          </div>
        </div>
        <!--- Card Five --->
        <div class="card">
          <!--- Card Header --->
          <div class="card-header bg-light" id="headingFive">
            <button
              class="mb-0 btn btn-link text-dark collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              <h4 class="text-left">Which Internet browsers are supported?</h4>
            </button>
          </div>
          <!--- Card Body --->
          <div
            id="collapseFive"
            class="collapse"
            aria-labelledby="headingFive"
            data-parent="#accordionOne"
          >
            <div class="card-body">
              <p class="lead">
                ERCCIS Data Search is currently supported on Google Chrome,
                Firefox and Microsoft Edge. If you are using Internet Explorer
                or other browsers, some functionality might be restricted.
              </p>
            </div>
          </div>
        </div>
        <!--- Card Six --->
        <div class="card">
          <!--- Card Header --->
          <div class="card-header bg-light" id="headingSix">
            <button
              class="mb-0 btn btn-link text-dark collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              <h4 class="text-left">
                Why is a recent biological record available on ORKS not showing
                on my Data Search report?
              </h4>
            </button>
          </div>
          <!--- Card Body --->
          <div
            id="collapseSix"
            class="collapse"
            aria-labelledby="headingSix"
            data-parent="#accordionOne"
          >
            <div class="card-body">
              <p class="lead">
                There is no live link between ERCCIS Data Search and ORKS, and
                because of the stringent validation and verification procedures
                which ERCCIS undertakes, there can be a delay of several months
                for the data to be reflected in ERCCIS Data Search reports.
              </p>
              <p>
                Please note, only Species of Conservation Concern (SoCC) are
                included, with additions from the Cornwall Red Data Book and the
                ERCCIS Invasive Species list. If you require data on non
                protected/priority species, please get in touch directly with
                ERCCIS.
              </p>
            </div>
          </div>
        </div>
        <!--- Card Seven --->
        <div class="card">
          <!--- Card Header --->
          <div class="card-header bg-light" id="headingSeven">
            <button
              class="mb-0 btn btn-link text-dark collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseSeven"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              <h4 class="text-left">
                I don’t understand the acronyms used in the designation columns
                of my Excel species datasheet?
              </h4>
            </button>
          </div>
          <!--- Card Body --->
          <div
            id="collapseSeven"
            class="collapse"
            aria-labelledby="headingSeven"
            data-parent="#accordionOne"
          >
            <div class="card-body">
              <p class="lead">
                To reduce the text string that is shown in your Excel species
                data report we use acronyms of the multiple international,
                national and local designations. All acronyms are listed in the
                ERCCIS Data Search explanatory document (EDS Jargon buster)
                which is delivered with your ERCCIS Data Search report or is
                available
                <a
                  href="https://cornwall-wildlife-trust.azurewebsites.net/static/ERCCIS_Data_Search-Report_Explained.pdf"
                  >here.</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import MainNav from "@/components/MainNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "FAQ",
  components: {
    MainNav,
    Footer
  },
  mounted() {
    this.$store.dispatch("getReportTypes");
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    reports() {
      return this.$store.getters.reports;
    }
  }
};
</script>
